import Accordian from "@components/Accordian/Accordian";
import { Grid } from "@mui/material";
import DateTime from "@mv-components/DateTime/DateTime";
import styles from "./styles";
import useStyles from "@hooks/useStyle";
import { AccordionDateTimePropsInterface } from "@mv-components/types";
import { InputType } from "@mv-types";

const AccordionDateTime = (props: AccordionDateTimePropsInterface) => {
	const { trigger, direction, onChange, iconProps, defaultExpanded } = props;

	const { classes } = useStyles(styles) as any;
	return (
		<Accordian iconProps={iconProps} trigger={trigger} defaultExpanded={defaultExpanded}>
			<Grid container direction={direction === "vertical" ? "column" : "row"} className={classes.dateContainer}>
				<DateTime
					{...props}
					elementType={InputType.DATE_TIME}
					onChange={({ event, itemKey, value }: any) => onChange({ event, itemKey, value })}
				/>
			</Grid>
		</Accordian>
	);
};

export default AccordionDateTime;
